var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSanta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 563.214,
    height: 559.038,
    viewBox: "0 0 563.214 559.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 563.214,
    height: 559.038,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666",
    transform: "translate(0 -0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    transform: "translate(0 0.004)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M78.447,1033.2a16.093,16.093,0,0,1-3.829-.463c-28.528-6.973-49.4-19.295-62.031-36.624-10.612-14.557-14.712-32-11.543-49.1,5.858-31.634,28.731-56.966,66.148-73.257,29.539-12.861,68.646-20.392,113.091-21.779a16.071,16.071,0,0,1,1,32.127c-40.41,1.261-75.426,7.874-101.263,19.123-27.557,12-43.5,28.7-47.374,49.638a31.249,31.249,0,0,0,5.912,24.316c7.926,10.871,23.033,19.286,43.689,24.335a16.073,16.073,0,0,1-3.8,31.687m320.972-13.256c-15.158,0-32.344-6.967-51.206-20.777-21.271-15.574-44.1-39.4-67.847-70.807A16.071,16.071,0,1,1,306,908.979c21.554,28.506,42.715,50.726,61.2,64.258,19.92,14.586,30.618,14.95,34.291,14.43,2.688-.38,5.483-1.537,7.722-7.376,1.924-5.02-.442-13.25-6.492-22.578-10.813-16.67-32.237-35.213-57.308-49.6-27.262-15.645-55.749-24.988-80.214-26.308a16.071,16.071,0,1,1,1.731-32.1c29.388,1.585,62.942,12.426,94.481,30.526,29.729,17.061,54.615,38.926,68.276,59.988,15.225,23.474,13.591,41,9.537,51.575-6.009,15.677-17.81,25.513-33.228,27.7a46.832,46.832,0,0,1-6.58.456",
    transform: "translate(0 -622.668)",
    fill: "#ea3a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M348.164,1149.387S372.64,836.265,479.746,839.049c122.074,3.175,150.946,308.444,150.946,308.444-87.249,31.531-204.387,30.334-282.528,1.893",
    transform: "translate(-255.142 -614.862)",
    fill: "#ea3a4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M379.416,1412.8l-2.634,10.775s-6.064,2.763-8.092,3.722c18.831-1.909,45.932-.133,46.505,6.761.713,8.582-28.917,15.986-59.711,9.678l1.666-22.111c9-.2,16.727-5.151,22.267-8.824",
    transform: "translate(-260.506 -1035.332)",
    fill: "#345f5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M304.033,1420.653c-.6-4.947-2.435-9.105-1.751-14.8,1-8.3,6.051-17.563-.031-25.205-4.739-5.955-13.118-3.336-16.255,2.535-2.761,5.167-.461,11.317-1.177,16.812-.916,7.04-5.177,12.658-3.275,20.285,1.413,5.667,3.736,10.668,9.735,11.671,6.619,1.106,13.748-3.1,12.754-11.3",
    transform: "translate(-205.967 -1009.302)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M782.929,1261.125a1.559,1.559,0,0,1-1.545-1.367c-4.534-36.387-8.5-92.641-10.1-143.314-1.426-45.07-1.781-107.646,4.628-149.8a1.559,1.559,0,0,1,3.083.469c-6.1,40.131-9.484,172.117,5.486,292.263a1.559,1.559,0,0,1-1.354,1.74,1.62,1.62,0,0,1-.195.012",
    transform: "translate(-564.582 -707.406)",
    fill: "#153939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M171.81,722.315c26.022-17.332,43.321,4.487,86.519-14.711,61.283-27.236,67.491-88.053,100.159-77.473,66.338,21.484-30.089,170.549-110.525,183.921C169.7,827.064,124.695,753.7,171.81,722.315",
    transform: "translate(-111.834 -460.879)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M805.293,661.574l-18.471,34.8c-11.621-12.04-27.687-20.307-43.9-20.443L761.7,641.312Z",
    transform: "translate(-544.43 -469.969)",
    fill: "#ffcfbb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M867.321,803.595c1.558-4.482.593-8.5-1.5-10.334-2.109-1.854-5.363-1.489-8.327,2.852a71.747,71.747,0,0,1,9.823,7.482",
    transform: "translate(-628.394 -580.545)",
    fill: "#feb0a4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M730.255,724.567c-1.711,18.74-21.041,32.446-34.025,10.856-2.69-4.474-1.613-8.325.731-9.823,1.956-1.248,4.789-.734,7.1,1.263,8.205,7.079,16.645,13.375,26.191-2.3",
    transform: "translate(-509.054 -530.98)",
    fill: "#feb0a4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M923.341,779.728l-6.263,11.207c4.8,6.919,12.442,6.234,14.82,3,2.839-3.858.617-11.4-8.558-14.208",
    transform: "translate(-672.056 -571.403)",
    fill: "#ffcebc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M842.133,766.153a2.193,2.193,0,1,0,1.375,2.589,2.079,2.079,0,0,0-1.375-2.589",
    transform: "translate(-615.304 -561.417)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M774.834,735.733a2.193,2.193,0,1,0,1.374,2.588,2.079,2.079,0,0,0-1.374-2.588",
    transform: "translate(-565.986 -539.125)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M938.918,804.485a1.362,1.362,0,0,1-1.358-1.291,3.548,3.548,0,0,0-1.268-2.5,3.916,3.916,0,0,0-2.567-1.031,1.36,1.36,0,1,1-.227-2.711,6.508,6.508,0,0,1,4.584,1.693,6.268,6.268,0,0,1,2.2,4.411,1.361,1.361,0,0,1-1.289,1.429l-.072,0",
    transform: "translate(-683.175 -584.014)",
    fill: "#feafa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M780.9,818.154h0c-2.394,0-5-2.108-5.119-6.008a1.559,1.559,0,1,1,3.117-.094c.059,1.937,1.077,2.983,2,2.983h0c.924,0,1.554-1.1,1.608-2.806a1.559,1.559,0,1,1,3.117.1c-.127,4.025-2.464,5.827-4.725,5.827",
    transform: "translate(-568.506 -593.983)",
    fill: "#153939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M849.522,732.052a10.591,10.591,0,0,0-4.56-4.809,9.706,9.706,0,0,0-6.709-.85,3.126,3.126,0,0,0,1.129,6.149,3.733,3.733,0,0,1,2.333.633,4.456,4.456,0,0,1,1.752,1.883,3.38,3.38,0,0,0,6.055-3.006",
    transform: "translate(-612.414 -532.129)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M775.13,697.306a10.593,10.593,0,0,0-5.089-4.245,9.707,9.707,0,0,0-6.762-.062,3.125,3.125,0,1,0,1.839,5.974,3.741,3.741,0,0,1,2.39.357,4.461,4.461,0,0,1,1.96,1.666,3.38,3.38,0,1,0,5.663-3.69",
    transform: "translate(-557.731 -507.423)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M959.618,89.547c-38.089,23.041-21.8,49.028-33.011,67.765-9.847,16.454-27.424,14.588-41.276,33.868C874,206.946,891.92,241.548,855.689,262.7l-49.1-28.74c8.956-26.713,26.706-20.57,36.655-32.824,9.356-11.522,5.81-23.8,15.173-36.566,11.46-15.63,35.3-12.343,45.355-25.318,12.081-15.589,13.771-48.054,55.847-49.71",
    transform: "translate(-591.085 -65.623)",
    fill: "#ea3a4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M1379.455,2.092c-11.477-9.5-33.626,15.924-20.175,25.937,14.4,10.717,32.816-15.475,20.175-25.937",
    transform: "translate(-993.032 -0.004)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M880.777,455.9c29.417-107.751,91.557-205.508,190.465-198.616,100.7,7.015,131.129,108.875,98.541,178.458-18.716,39.965-82.2,66.8-128.66,54.066-65.251-17.891-109.863-64.289-149.717-25.686-8.311,23.191-22.356,44.894-22.356,44.894L844.8,488.5c8.33-6.274,24.769-17.43,35.982-32.591",
    transform: "translate(-619.085 -188.296)",
    fill: "#2a8b5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M1372.568,511.012c-9.8,15.193-17.177,34.293-23.02,55.88l46.658,19.809c8.88-23.5,18.031-44.558,27.824-59.818Z",
    transform: "translate(-988.979 -374.482)",
    fill: "#ea3a4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M1377.055,643.8a1.56,1.56,0,0,1-1.418-2.208c.75-1.64,1.522-3.272,2.294-4.9,1.028-2.174,2.091-4.421,3.075-6.639a1.559,1.559,0,1,1,2.851,1.265c-1,2.252-2.071,4.517-3.106,6.707-.767,1.621-1.533,3.241-2.277,4.868a1.559,1.559,0,0,1-1.419.911m-7-4.091a1.56,1.56,0,0,1-1.425-2.191l.258-.583a80.932,80.932,0,0,1,4.983-9.97,1.56,1.56,0,0,1,2.655,1.638,77.407,77.407,0,0,0-4.787,9.594l-.259.584a1.558,1.558,0,0,1-1.426.928m-.239-33.16a1.557,1.557,0,0,1-.56-.1l-.593-.228a80.993,80.993,0,0,1-10.208-4.481,1.559,1.559,0,1,1,1.5-2.733,77.535,77.535,0,0,0,9.823,4.3l.595.229a1.559,1.559,0,0,1-.559,3.015m2.751-6.979a1.545,1.545,0,0,1-.576-.111c-1.683-.67-3.36-1.362-5.037-2.055-2.214-.914-4.5-1.86-6.76-2.73a1.559,1.559,0,1,1,1.12-2.91c2.292.883,4.6,1.836,6.83,2.758,1.664.687,3.329,1.375,5,2.04a1.559,1.559,0,0,1-.577,3.008",
    transform: "translate(-994.912 -433.586)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M1516.806,573.3a1.554,1.554,0,0,1-.625-.131c-3.664-1.6-7.24-3.2-10.707-5.031a1.56,1.56,0,0,1,1.46-2.756c3.372,1.787,6.89,3.352,10.5,4.931a1.559,1.559,0,0,1-.625,2.988m2.148-6.947a1.564,1.564,0,0,1-.591-.117c-1.633-.67-3.259-1.4-4.832-2.108-1.46-.656-2.97-1.334-4.461-1.953a1.559,1.559,0,1,1,1.194-2.881c1.534.636,3.065,1.324,4.545,1.989,1.55.7,3.153,1.417,4.738,2.067a1.56,1.56,0,0,1-.592,3m5.57-12.891a1.55,1.55,0,0,1-.59-.117c-2.975-1.218-5.912-2.527-9.406-4.119a1.559,1.559,0,1,1,1.293-2.838c3.46,1.576,6.365,2.872,9.295,4.07a1.56,1.56,0,0,1-.592,3m-25.594-30.207a1.56,1.56,0,0,1-1.421-2.2c.791-1.755,1.69-3.465,2.56-5.118.5-.944.995-1.889,1.472-2.844a1.559,1.559,0,0,1,2.788,1.4c-.487.974-.995,1.936-1.5,2.9-.848,1.612-1.725,3.279-2.477,4.947a1.558,1.558,0,0,1-1.422.919",
    transform: "translate(-1097.307 -375.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M938.282,974.389c-13.217-10.423-8.318-25.367-12.314-26.674-3.925-1.284-6.291,12.906-.317,24.267-13.9-12.847-36.622-27.724-41.224-22.559-5.729,6.428,13.494,30.161,41.893,43.636Z",
    transform: "translate(-647.386 -694.449)",
    fill: "#345f5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M1110.687,1157.095a1.555,1.555,0,0,1-.92-.3c-21.861-16.039-44.8-39.851-68.183-70.776a1.559,1.559,0,0,1,2.488-1.88c23.2,30.683,45.923,54.282,67.539,70.141a1.559,1.559,0,0,1-.923,2.817m-5.645-51.085a1.556,1.556,0,0,1-1.113-.467,432.638,432.638,0,0,1-35.461-41.741,1.559,1.559,0,0,1,2.488-1.881,429.643,429.643,0,0,0,35.2,41.438,1.56,1.56,0,0,1-1.113,2.651",
    transform: "translate(-763.065 -777.747)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M812.4,647.751a12.416,12.416,0,0,1-9.642-4.57c-9.015-11.033-33.457-24.016-48.43-25.726a12.442,12.442,0,1,1,2.823-24.724c21.456,2.45,51.773,18.667,64.877,34.7a12.443,12.443,0,0,1-9.627,20.316",
    transform: "translate(-544.706 -434.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M1026.579,1053.3c2.408-4.362,3.354-8.807,7.239-13.023,5.665-6.148,15.184-10.7,14.725-20.456-.358-7.6-8.686-10.382-14.665-7.457-5.261,2.574-7,8.907-10.793,12.945-4.863,5.171-11.6,7.234-14.527,14.532-2.17,5.422-3.213,10.837,1.065,15.159,4.72,4.771,12.963,5.531,16.956-1.7",
    transform: "translate(-737.712 -741.049)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M490.293,1594.815c-38.149,0-75.406-1.126-107.669-4.777a4.77,4.77,0,0,1,1.072-9.479c59.146,6.692,135.786,4.8,203.406,3.125,17.735-.439,34.486-.853,50.467-1.109a4.77,4.77,0,0,1,.152,9.539c-15.939.255-32.671.668-50.383,1.106-31.277.774-64.487,1.594-97.045,1.594",
    transform: "translate(-277.293 -1158.248)",
    fill: "#345f5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M749.671,1593.654a12.668,12.668,0,0,1-5.073-1.071c-4.036-1.762-9.494-7.6-7.991-16.475a13.434,13.434,0,0,1,6.057-9.582,11.46,11.46,0,0,1,9.662-.971c4.977,1.656,7.054,5.46,8.43,8.963a17.062,17.062,0,0,1,1.155,8.616,12.752,12.752,0,0,1-6.495,9.085,12.187,12.187,0,0,1-5.745,1.435m-1.2-26.013a8.506,8.506,0,0,0-4.41,1.219,10.766,10.766,0,0,0-4.775,7.7c-.655,3.865.5,10.954,6.4,13.527a9.654,9.654,0,0,0,8.449-.271,10.049,10.049,0,0,0,5.1-7.171,14.005,14.005,0,0,0-1.01-7.135c-1.121-2.854-2.659-6.012-6.756-7.375a9.477,9.477,0,0,0-2.993-.5",
    transform: "translate(-539.616 -1146.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M426.469,1974.208a1011.826,1011.826,0,0,1-130.052-8.388A15.034,15.034,0,1,1,300.281,1936a985.135,985.135,0,0,0,284.734-4.683A15.034,15.034,0,1,1,589.838,1961a1018.529,1018.529,0,0,1-163.368,13.21",
    transform: "translate(-207.618 -1415.171)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanta);
export default __webpack_public_path__ + "static/media/santa.d79d47cf4654984534706f24819960ad.svg";
export { ForwardRef as ReactComponent };